import styled from "styled-components";
import { Drawer } from "@material-ui/core";

const DrawerWrapper = styled(Drawer)`
  .drawer-container {
    width: 300px;
    .jukin-logo {
      margin-top: 25px;
      margin-left: 25px;
      position: relative;
      a.logo {
        display: block;
        svg.logo {
          width: 45px;
          height: 45px;
        }
      }
      .st0 {
        fill: ${(props) => props.theme.colorFlamingo};
      }

      .st1 {
        fill: #fff;
      }
    }
    .list--profile {
      background-color: #E8FB98;
      height: 64px;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      a {
        &:hover,
        &.active {
          color: ${(props) => props.theme.colorFlamingo};
        }
      }
    }
    .list {
      overflow: auto;
      height: 100%;
      &.list--logged {
        overflow-x: hidden;
      }
      ul {
        width: 300px;
        a {
          display: block;
          width: 100%;
          &:hover,
          &.active {
            color: #1EBEC8;
          }
        }
      }
      .list--route-contact {
        margin-bottom: 15px;
      }
      .nested {
        padding-left: 80px;
        &.showall {
          font-size: 13px;
        }
        .nested--text {
          font-size: 13px;
        }
      }
    }

    .list--button {
      height: 250px;
      padding-bottom: 0;

      .cta--bottom {
        text-align: center;
        background-color: #ffffff;
        a {
          width: 100%;
        }
        .cta {
          width: 100%;
          margin-left: auto;
          margin-right: auto;
        }
        .cta--type-signup,
        .cta--type-cart {
          background-color: #1EBEC8;
          color: #fff;
        }
        .cta--type-login,
        .cta--type-playlist {
          color: rgba(0, 0, 0, 0.6);
          border: 1px solid rgba(0, 0, 0, 0.12);
          margin-bottom: 20px;
        }
        .cta--span-out {
          text-decoration: underline;
          color: rgba(0, 0, 0, 0.6);
          display: block;
          text-align: left;
          margin-left: 55px;
          cursor: pointer;

          &:hover {
            text-decoration: none;
            color: #1EBEC8;
          }
        }
      }
    }
  }
`;

export default DrawerWrapper;
